import { render, staticRenderFns } from "./associationDetail.vue?vue&type=template&id=c0a52606&"
import script from "./associationDetail.vue?vue&type=script&lang=js&"
export * from "./associationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports